module.exports = __webpack_public_path__ + "static/media/beautiful-bean-co-red.9d664f41.svg";